import React from 'react';
import { FinalGradeContainer } from './styled';
import iconFinalGrade from '../../../../../../../assets/icons/courses/iconFinalGrade.svg';

interface IProps {
  finalGrade: string;
  courseStatus: string;
}

const FinalGradeBlock = (props: IProps) => {
  const { finalGrade, courseStatus } = props;

  let color = 'var(--grade-ongoing)';

  if (courseStatus === 'Aprobado') color = 'var(--grade-success)';
  else if (courseStatus === 'Desaprobado') color = 'var(--grade-failed)';
  else if (courseStatus === 'Retirado') color = 'var(--grade-retired)';

  return (
    <FinalGradeContainer style={{ background: color }}>
      <div style={{ display: 'flex' }}>
        {' '}
        <img src={iconFinalGrade} alt="grade" />
        Promedio:{' '}
        {finalGrade && Number(finalGrade) > 0 ? <b>{finalGrade}</b> : <b>--</b>}
      </div>
      <span>{courseStatus}</span>
    </FinalGradeContainer>
  );
};

export default FinalGradeBlock;
